import * as Cookies from "js-cookie";

export default {
  name: "set-token",
  req(payload) {
    let token = Cookies.getJSON("token");

    if (token) {
      payload.req.headers["Authorization"] = `Bearer ${token.access_token}`;
    }

    return payload;
  }
};
